import SyncableModel from './SyncableModel';
import { getRootStore } from "../utils/root-store"

export default class Product extends SyncableModel {
    static name = 'Product'

    _fillable = [
      'id', 'product_category_id', 'image',
      'code', 'name', 'aliases', 'unit',
      'is_bought', 'buy_price', 'is_sold',
      'sell_price', 'description', 'verified', 'created_by', 'updated_by',
      'created_at', 'updated_at', 'producer_id', 'popularity', 'synced_at', 'deleted_at'
    ]

    _casts = {
      is_bought: 'bool',
      buy_price: 'float',
      is_sold: 'bool',
      sell_price: 'float',
      verified: 'bool',
    };

    static endpoint = '/products'

    static syncOnly = true


  static async syncAll(
    params = {}, sqlParams = [], cleanAfterSync = true,
    onSyncProgressUpdate = undefined, onError = undefined
  ) {
    const { userStore: { user } } = getRootStore();
    const _params = { ...params };
    const _sqlParams = [...sqlParams];
    if (user && user.role_id === 1 && !_params.id__in) {
      _params.has = 'stock.farm.farm_user';
    }
    return super.syncAll(_params, _sqlParams, cleanAfterSync, onSyncProgressUpdate, onError);
  }
}
